import React from 'react';
import { StyleProp, TextStyle } from 'react-native';
import { UseFormReturn } from 'react-hook-form';
import { translate } from '../../../services/translate';
import { groupPermissionsStructure } from '../../../pages/access/Groups/GroupForm';
import FormDropDownPicker from '../../../components/FormDropDownPicker';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';

type Props = {
    zIndex: number;
    disabled?: boolean;
    required?: boolean;
    labelFontSize?: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    label?: string;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: (keyof GroupPermissions)[];
    setValue: React.Dispatch<React.SetStateAction<(keyof GroupPermissions)[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function GroupPermissionsDropdown({ form, fieldName, value, setValue, zIndex, disabled, required, labelFontSize = 16, labelStyle, viewStyle, label }: Props) {

    const selectablePermissions = groupPermissionsStructure
        .flatMap(({ title, values }) =>
            values.map(permission => ({
                value: permission.value as keyof GroupPermissions,
                label: `${translate(title)} - ${translate(permission.label)}`,
            }))
        );

    if (form && fieldName) {
        return <FormDropDownPicker
            label={label ?? translate('permissions')}
            items={selectablePermissions}
            multiple={true}
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            fieldName={fieldName}
            form={form}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            mode='BADGE'
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={label ?? translate('permissions')}
                items={selectablePermissions}
                multiple={true}
                setValue={setValue}
                mode='BADGE'
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
                labelFontSize={labelFontSize}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
            />
        );
    }
}

export default GroupPermissionsDropdown;
